type SessionStorageKey = 'blogIndexQueryParams';

export const getSessionStorage = (key: SessionStorageKey): null | string => {
  if (typeof window === 'undefined') {
    return null;
  }

  const item = sessionStorage.getItem(key);

  return item ?? null;
};

export const setSessionStorage = (key: SessionStorageKey, value: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(key, value);
};
